/* eslint-disable */
"use strict";

var config, service, benetton;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  benetton = config.VUE_APP_MOL_S_BENETTON
}

async function importaOrdini(soloExcel) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(
    `${service}/${benetton}/elabora/ordini${soloExcel ? "?excel=true" : ""}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    }
  );
  return await response.json();
}

async function importaPacking() {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${benetton}/elabora/packing`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  return await response.json();
}

async function importaNegozi() {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${benetton}/elabora/negozi`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  return await response.json();
}

async function generaCategorie() {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${benetton}/genera/categorie`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  return await response.json();
}

async function inviaFileForm(form_data) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${benetton}/send-file`, {
      method: "POST",
      body: form_data,
    });
    return await response.text();
  } catch (err) {
    return err;
  }
}

async function getFileList(tipo, filtro) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(
    `${service}/${benetton}/dir/${tipo}?flt=${filtro}`
  );
  return await response.json();
}

async function deleteFile(file) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    file,
  };
  const response = await fetch(`${service}/${benetton}/dir/delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function statoElaborazione() {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${benetton}/elaborazione/stato`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return await response.json();
  } catch (err) {
    return err;
  }
}

function getPathFileRighe(tipo) {
  return `${service}/${benetton}/elaborazione/righe${
    tipo ? "&tipo=" + tipo : ""
  }`;
}

export default {
  importaOrdini,
  importaPacking,
  importaNegozi,
  generaCategorie,
  inviaFileForm,
  getFileList,
  deleteFile,
  statoElaborazione,
  getPathFileRighe,
};
